export const publicVersion = "2.7.0-0-gec2df689-2026-05-06T11-21-14Z";